<script>
export default {
  name: 'VulnerabilityDetail',
  props: {
    label: {
      type: String,
      required: true,
    },
  },
};
</script>

<template>
  <div class="d-sm-flex my-sm-2 my-4">
    <label class="col-sm-2 text-sm-right gl-font-weight-bold gl-pl-0">{{ label }}:</label>
    <div class="col-sm-10 gl-pl-0 gl-text-gray-500">
      <slot></slot>
    </div>
  </div>
</template>
